export default __webpack_public_path__ + "0bc0254ba879b5be4ce2a7f1438d353a.png";